// src/store/store.ts
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./slices/authSlice"; // Importez le reducer auth
import UserAPI from "../services/UserAPI";
import MediaAPI from "../services/MediaAPI";
import AnimationsAPI from "../services/AnimationsAPI";
import IncidentAPI from "../services/IncidentAPI";
import ReservationAPI from "../services/ReservationAPI";
import notificationReducer from "../store/slices/notificationSlice"; // Importez le reducer notif
import botReducer from "../store/slices/botSlice"; // Importez le reducer bot
import botConfigReducer from "./slices/botConfigSlice";
import BotConfigAPI from "../services/BotConfigAPI";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    AnimationsAPI.reducerPath,
    IncidentAPI.reducerPath,
    ReservationAPI.reducerPath,
    BotConfigAPI.reducerPath,
  ],
};

const rootReducer = combineReducers({
  AnimationsAPI: AnimationsAPI.reducer,
  UserAPI: UserAPI.reducer,
  MediaAPI: MediaAPI.reducer,
  IncidentAPI: IncidentAPI.reducer,
  ReservationAPI: ReservationAPI.reducer,
  Auth: authReducer,
  Notification: notificationReducer,
  Bot: botReducer,
  BotConfig: botConfigReducer,
  BotConfigAPI: BotConfigAPI.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const GlobalStore = configureStore({
  reducer: persistedReducer,

  // - Caching
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      AnimationsAPI.middleware,
      IncidentAPI.middleware,
      UserAPI.middleware,
      MediaAPI.middleware,
      ReservationAPI.middleware,
      BotConfigAPI.middleware,
    ),
});
export const persistor = persistStore(GlobalStore);

setupListeners(GlobalStore.dispatch);

export type RootState = ReturnType<typeof GlobalStore.getState>;
export type AppDispatch = typeof GlobalStore.dispatch;

export default GlobalStore;
